<template>
    <div class="bank-account-owner-data-container">
        <div class="content-container">
            <div class="personal-data-wrapper">
                <h1>Bankverbindung ändern</h1>

                <!--<EditBankData :bankData="bankAccountOwner.bankData"></EditBankData>-->

                <EditPersonalData :customer="bankAccountOwner" :with-bank-data="true" :subtitle="$t('general.bank-acount-owner')" @submit="handleSubmit"/>
            </div>
        </div>

        <PopUp title="Datenänderung beantragen" :open="showAreYouSure" submit-label="Beantragen" cancel-label="Abbrechen" @close="handleClose">
            <label>Ihre Änderungen werden beantragt. Nach dem Absenden kann es einige Tage dauern, bis Ihre Daten geprüft und aktualisiert werden.</label>
        </PopUp>
    </div>
</template>

<script>
import axios from 'axios'

import PopUp from '@elements/PopUp.vue'
import EditPersonalData from '@components/EditPersonalData.vue'

export default {
    name: 'bank-account-owner-data-page',
    inject: [ 'util', 'globalState', 'toast'],
    data() {
        return {
            bankAccountOwner: {},
            submitBankAccountOwner: undefined,
            showAreYouSure: false
        }
    },
    mounted() {
        this.init()
    },
    computed: {
        bankAccountOwnerId() {
            return encodeURIComponent(this.$route.params.id)
        }
    },
    methods: {
        async init() {
            this.globalState.isLoading = true

            let getBankAccountOwnerUrl = this.util.middleware()
            getBankAccountOwnerUrl += '/bank-account-owners/' + this.bankAccountOwnerId

            axios.get(getBankAccountOwnerUrl)
            .then(response => {
                this.bankAccountOwner = response.data
                this.globalState.isLoading = false
            })
            .catch(() => {
                const errorMessage = this.$t('general.error')
                this.toast.error(errorMessage) 
            })
        },
        handleSubmit(event) {
            //console.log(event)

            if (event) {
                this.submitBankAccountOwner = event
                this.showAreYouSure = true
            }
        },

        handleClose(event) {
            if (event) {
                this.globalState.isLoading = true

                let requestChangesUrl = this.util.middleware()
                requestChangesUrl += '/bank-account-owners/' + this.submitBankAccountOwner.id

                //convert birthdate value to UTC timezone
                this.submitBankAccountOwner.birthdate = this.util.convertLocalToUtcDate(this.submitBankAccountOwner.birthdate)

                axios.put(requestChangesUrl, this.submitBankAccountOwner)
                .then(response => {
                    if(response) {
                        this.submitBankAccountOwner = undefined
                        this.showAreYouSure = false
                        this.globalState.isLoading = false
                        this.$router.push('/')
                    }
                })
                .catch(() => {
                    // TODO:
                    this.showAreYouSure = false
                    this.submitBankAccountOwner = undefined
                    const errorMessage = this.$t('general.error')
                    this.toast.error(errorMessage) 
                })
            } else {
                this.submitBankAccountOwner = undefined
                this.showAreYouSure = false
            }
        }
    },
    components: {
        EditPersonalData,
        //EditBankData,
        PopUp
    }
}
</script>

<style lang="scss" scoped>
.bank-account-owner-data-container {
    width: 100%;

    > .content-container {
        padding-bottom: 16px;
    }
}

.personal-data-wrapper {
    background-color: #fff;
    padding: 16px;
    border-radius: 8px;
    box-shadow: 0 2px 8px #00000022;

    > h1 {
        margin: 0;
    }

    > div {
        margin-top: 40px;
    }
}
</style>